<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind="$attrs">
    <path fill="currentColor" d="M12 2c.863 0 1.701.11 2.5.315L14 4.252A8 8 0 0 0 4 12c0 1.334.325 2.617.94 3.766l.35.653l-.656 2.947l2.947-.655l.653.35A7.96 7.96 0 0 0 12 20a8 8 0 0 0 7.943-8.954l1.987-.236q.07.585.07 1.19c0 5.523-4.477 10-10 10a9.96 9.96 0 0 1-4.709-1.176L2 22l1.176-5.291A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m7.53-.68a.507.507 0 0 1 .94 0l.254.61a4.37 4.37 0 0 0 2.25 2.327l.717.32a.53.53 0 0 1 0 .962l-.758.338a4.36 4.36 0 0 0-2.22 2.25l-.246.566a.506.506 0 0 1-.934 0l-.247-.565a4.36 4.36 0 0 0-2.219-2.251l-.76-.338a.53.53 0 0 1 0-.963l.718-.32a4.37 4.37 0 0 0 2.251-2.325z" />
  </svg>
</template>
